import { render, staticRenderFns } from "./app-title.vue?vue&type=template&id=68204376&"
import script from "./app-title.vue?vue&type=script&lang=ts&"
export * from "./app-title.vue?vue&type=script&lang=ts&"
import style0 from "./app-title.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports